export default __webpack_public_path__ + "static/media/health.9d4a08c6.svg";